import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import Layout from "./layout/Layout";
import { renderRoutes } from "./components/config/routes"
import UniversalLoader from "./components/universalLoader";
import { checkDomainIsCaptis } from "./utils/Index";

function App() {
  const IsCaptis = checkDomainIsCaptis();
  if (IsCaptis) {
    // Change logo for Captis brand
    document.getElementById("favicon").href = "Captis/favicon.ico";
    // Change color for Captis brand
    const root = document.documentElement;
    root?.style.setProperty(
      "--background-color",
      checkDomainIsCaptis()
        ? "#3170EB"
        : "#8a2be2"
    );

    // Change manifest for Captis brand
    var myDynamicManifest = {
      short_name: "CaptisPay",
      name: "CaptisPay App",
      icons: [
        {
          src: window.location.host + "/Captis/logo192.png",
          type: "image/png",
          sizes: "192x192",
        },
        {
          src: window.location.host + "/Captis/logo512.png",
          type: "image/png",
          sizes: "512x512",
        },
      ],
      start_url: window.location.origin,
      display: "standalone",
      theme_color: "#000000",
      background_color: "#ffffff",
    };
    const stringManifest = JSON.stringify(myDynamicManifest);
    const blob = new Blob([stringManifest], { type: "application/json" });
    const manifestURL = URL.createObjectURL(blob);
    document
      .getElementById("my-manifest-placeholder")
      .setAttribute("href", manifestURL);
  } else {
    document.getElementById("favicon").href = "favicon.ico";
  }
  const currentRole = localStorage.getItem("superuser");

  return (
    <Router>
         <Layout>
          <UniversalLoader/>
          <Switch>
            {renderRoutes.map(([key, route]) => {
              // Check if the user has permission to access this route
              if (!route.role || route.role.includes(currentRole)) {
                return (
                  <route.type
                    key={key}
                    exact
                    render={() => {
                      document.title = `${route?.name ? route.name + " | " : ""}${IsCaptis ? 'Captis' : 'PatronPay'}`;
                      return <route.component />
                    }}
                    path={route.path}
                  />
                );
              }
            })}
          </Switch>
          </Layout>
    </Router>
  );
}

export default App;